import { gql } from "@apollo/client";

const ADD_PRODUCT = gql`
  mutation AddProduct(
    $productName: String!
    $users: [User_Product_Input]!
    $agreement: String
    $agreementSignature: String
    $agreementSignatureDate: String
    $availableToGrant: Float
    $cash: Float
    $impactInvestments: Float
    $lastUpdatedBy: String
    $notes: String
    $other: Float
    $portfolioBalance: Float
    $productType: String
    $stocks: Float
    $totalContributed: Float
    $totalGranted: Float
  ) {
    addProduct(
      product_name: $productName
      users: $users
      agreement: $agreement
      agreement_signature: $agreementSignature
      agreement_signature_date: $agreementSignatureDate
      available_to_grant: $availableToGrant
      cash: $cash
      impact_investments: $impactInvestments
      last_updated_by: $lastUpdatedBy
      notes: $notes
      other: $other
      portfolio_balance: $portfolioBalance
      product_type: $productType
      stocks: $stocks
      total_contributed: $totalContributed
      total_granted: $totalGranted
    ) {
      _id
      agreement
      agreement_signature
      agreement_signature_date
      available_to_grant
      cash
      impact_investments
      last_updated_by
      notes
      other
      portfolio_balance
      product_name
      product_type
      quarterly_fee
      stocks
      test_data
      total_contributed
      total_granted
    }
  }
`;

const UPDATE_PRODUCT = gql`
  mutation UpdateProduct($args: CombinedUpdateProductInput!, $productId: ID!) {
  updateProduct(args: $args, productId: $productId) {
    ... on DafProduct {
      _id
      name
    }
  }
}
`;

const DELETE_PRODUCT = gql`
  mutation DeleteProduct($productId: ID!) {
    deleteProduct(product_id: $productId) {
      _id
      product_type
      product_name
      available_to_grant
      cash
      agreement
      signature_date
      last_updated_by
      document_id
      fee_id
      owner_id {
        _id
      }
      successor_id {
        _id
      }
      advisor_id {
        _id
      }
      user_id {
        _id
      }
    }
  }
`;

const REMOVE_ADDITIONAL_USER_FROM_USER_PRODUCT = gql`
  mutation DeleteUserProduct($userProductId: ID) {
    deleteUserProduct(userProductId: $userProductId) {
      _id
      associationType
      createdAt
      expectedEmail
      expectedFirstName
      expectedLastName
      inviteConfirmationToken
      inviteExpirationDate
      inviteStatus
      relationship
      successorPriority
      updatedAt
      meta {
        testData
      }
    }
  }
`;









const ADD_ADDITIONAL_USER_TO_PRODUCT = gql`
  mutation Mutation($productId: ID!, $userId: [ID]) {
    addUsersToProduct(product_id: $productId, user_id: $userId) {
      _id
      user_id {
        _id
        first_name
        last_name
        middle_name
        address_1
        address_2
        city
        country
        date_of_birth
        email
        mobile_phone
        role
        state
        suffix
        zip
      }
    }
  }
`;

export {
  ADD_PRODUCT,
  UPDATE_PRODUCT,
  DELETE_PRODUCT,
  ADD_ADDITIONAL_USER_TO_PRODUCT,
  REMOVE_ADDITIONAL_USER_FROM_USER_PRODUCT,
};